export default "__VITE_ASSET__ed52df6f__"